/**
 * Legend row shown once at the top of the plant schema page so operators know
 * what the coloured dots on each leaf mean. Concept B.5: bewusst sichtbar
 * halten, was live und was veraltet ist.
 */
export function FreshnessLegend() {
  return (
    <div class="hv-freshness-legend" role="note" aria-label="Legende Datenfrische">
      <LegendItem tone="ok" label="Live" />
      <LegendItem tone="warn" label="Stale" />
      <LegendItem tone="error" label="Getrennt" />
      <LegendItem tone="error" label="Ungültig" />
      <LegendItem tone="info" label="Override" />
    </div>
  );
}

function LegendItem({ tone, label }: { tone: 'ok' | 'warn' | 'error' | 'info'; label: string }) {
  return (
    <span class="hv-freshness-legend__item">
      <span class={`hv-leaf__dot hv-leaf__dot--${tone}`} />
      <span class="hv-freshness-legend__label">{label}</span>
    </span>
  );
}
